import { WithPagination } from '@bv/api/crud';

import type { StepConfig } from '../../types/workflow';

class ClosingNotesApi extends WithPagination {
  constructor() {
    super('conversations/closing-notes?limit=1000');
  }
}

const closingNotesApi = new ClosingNotesApi();

const closeConversation: StepConfig = {
  // Design
  icon: 'closeConversation',
  headerTextColor: '#FF5C53',
  headerColor: '#FFDDDB',
  title: 'Close Conversation',
  text: '',
  category: 'Node',
  desc: 'Closes the conversation with closing notes.',

  // Form
  formFields: [
    {
      key: 'closingNoteId',
      type: 'select',
      label: 'Closing Note Category',
      placeholder: 'Select a closing note category (optional)',
      show: true,
      options: () => {
        // Return a function that will be called by FormField to fetch closing notes using the API instance
        return async () => {
          const { data, meta } = await closingNotesApi.paginated();
          return {
            meta,
            data: (data as Array<{ category: string; _id: string }>).map((note) => ({
              label: note.category,
              value: note._id,
            })),
          };
        };
      },
    },
    {
      key: 'summary',
      type: 'textarea',
      label: 'Summary',
      placeholder: 'Leave Your Comment Here ...',
      show: true,
      validation: {
        required: false,
        maxLength: 500,
      },
    },
  ],
};

export default closeConversation;
